export const categories: any = {
    "Data Science": -2,
    "Dev ops": -1,
    Frontend: 0,
    Backend: 1,
    Languages: 2
};

export const projects = [
    // Data science
    { name: "TensorFlow", time: 1, type: -2 },
    { name: "Scrapy", time: 6, type: -2 },
    { name: "Graph databases", time: 6, type: -2 },
    { name: "D3.js", time: 12, type: -2 },
    { name: "Panda", time: 3, type: -2 },
    // Dev ops
    { name: "Docker", time: 12, type: -1 },
    { name: "Docker compose", time: 12, type: -1 },
    { name: "Serverless", time: 6, type: -1 },
    { name: "Heruku", time: 2, type: -1 },
    { name: "Amazon EC2", time: 2, type: -1 },
    // Frontend
    { name: "Vue", time: 12, type: 0 },
    { name: "Angular", time: 6, type: 0 },
    { name: "Jquery", time: 36, type: 0 },
    { name: "Bootstrap", time: 24, type: 0 },
    { name: "Bootstrap", time: 24, type: 0 },
    { name: "Qt", time: 6, type: 0 },
    // Backend
    { name: "Django", time: 24, type: 1 },
    { name: "Flask", time: 6, type: 1 },
    { name: "Express", time: 12, type: 1 },
    { name: "AWS Lambda", time: 7, type: 1 },
    { name: "AWS DynamoDb", time: 7, type: 1 },
    { name: "AWS Cognito", time: 7, type: 1 },
    { name: "Nginx", time: 12, type: 1 },
    { name: "Redis", time: 4, type: 1 },
    // Languages
    { name: "Neo4j", time: 6, type: 2 },
    { name: "Python", time: 84, type: 2 },
    { name: "Node", time: 38, type: 2 },
    { name: "Mysql", time: 12, type: 2 },
    { name: "Php", time: 6, type: 2 },
    { name: "Java", time: 12, type: 2 },
    { name: "C#", time: 6, type: 2 },
    { name: "C++", time: 12, type: 2 },
    { name: "C", time: 6, type: 2 },
    { name: "TypeScript", time: 7, type: 2 }
];